import type { ComponentPropsWithoutRef, FC } from 'react';
import { getBaseActionClasses } from 'src/components/buttons-and-actions/button';
import { cn } from 'src/utils/cn';

export const RemoveButton: FC<
  ComponentPropsWithoutRef<'button'> & { error?: boolean }
> = ({ error, ...props }) => {
  return (
    <button
      type="button"
      {...props}
      className={cn(
        getBaseActionClasses({}),
        `
          h-full appearance-none border-none bg-transparent p-0
          text-foreground-surface-default
          focus-visible:spaced-focus-style
        `,
        error &&
          `
            border-border-support-error-subdued
            bg-background-support-error-minimal text-foreground-support-error
          `,
        props.disabled
          ? `
            pointer-events-none cursor-not-allowed
            border-border-surface-disabled bg-background-surface-disabled
            text-foreground-surface-disabled
          `
          : 'hover:text-foreground-secondary-hover',
        props.className
      )}
    />
  );
};
